import { render, staticRenderFns } from "./Agricola.vue?vue&type=template&id=31a566cc&scoped=true&lang=pug"
import script from "./Agricola.vue?vue&type=script&lang=js"
export * from "./Agricola.vue?vue&type=script&lang=js"
import style0 from "./Agricola.vue?vue&type=style&index=0&id=31a566cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a566cc",
  null
  
)

export default component.exports